// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__t8fKH","buttons":"PendingPaymentAlert_buttons__3Fnrc"};